import http from "../http-common";

class OrderService {
    createOrder(data) {
        return http.post("order/create", data);
    }
    verifyPayment(data) {
        return http.post("order/payment/verify", data);
    }

}

export default new OrderService();